import { makeStyles } from '@fluentui/react-components';

export const submenuStyles = makeStyles({
  itemContent: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    minWidth: '160px',
  },
});
